import React from "react"
import { ButtonLoadingSeeker } from "@ui-seeker/core"

import { useCommonFilter } from "@hooks"
import { isLoadingCommonFilters } from "@signals"
import { filterSearchButtonProps } from "@components/@base/FilterPanel"


export default function CommonFiltersFooterActions(
	{
		onSubmit = null,
		schema = null,
		isValid,
		isLoading,
		...props
	}) {
	const { disableButton, handleSubmit } = useCommonFilter(isValid)

	return <ButtonLoadingSeeker
		loading={isLoadingCommonFilters.value || isLoading}
		{...filterSearchButtonProps}
		onClick={() => handleSubmit(onSubmit, schema)}
		disabled={disableButton}
		{...props.loadingProps}
	>
		Search
	</ButtonLoadingSeeker>
}
